var cursorMap = {
    pointer: "pointer",
    default: "default",
    grab: "grab",
    move: "move",
    none: "none",
    text: "text",
    wait: "wait",
    notAllowed: "not-allowed",
    initial: "initial",
    inherit: "inherit",
};
export default (function (_a) {
    var cursor = _a.cursor;
    if (!cursor)
        return "";
    return cursor in cursorMap ? "cursor: ".concat(cursorMap[cursor], ";") : "";
});
